import { render, staticRenderFns } from "./BlockEditorPage.vue?vue&type=template&id=71d27a66&scoped=true"
import script from "./BlockEditorPage.vue?vue&type=script&lang=js"
export * from "./BlockEditorPage.vue?vue&type=script&lang=js"
import style0 from "./BlockEditorPage.vue?vue&type=style&index=0&id=71d27a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d27a66",
  null
  
)

export default component.exports